module.exports = __webpack_public_path__ + "static/media/MD_TutorialSlides_10202020_14_EQ.1bfd124d.png";